import { Injectable } from '@angular/core';
import { Location } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor(private location: Location, private translate: TranslateService, ) { }
  getLocation() {
    return this.location["_platformStrategy"]["_platformLocation"].location;
  };
  getLanguages() {
    return ['fi', 'en', 'dut'];
  }


  getLanguage() {
    if (this.pathName() == "en" || this.pathName() == "fi") {
      return this.getLocation().pathname.split("/")[1];
    }

    return localStorage.getItem("currentLanguage") || this.translate.currentLang;
  }


  pathName() {
    return this.getLocation().pathname.split("/")[1];
  }

  setLanguageForApp(lang) {
    // debugger;
    localStorage.setItem('currentLanguage', lang);
    // this.translate.use('en');
    let currentLang = this.getLanguage();
    let path = this.getLocation().href.split("?");
    if(path.length > 0)
    {
      path = path[1];
      if(path !== undefined)
      {
        let location_ = this.getLocation().pathname.replace(`/${currentLang}`, `/${lang}`);
        location_ = `${location_}?${path}`;
        this.location.go(location_);
      }
      else
      {
        this.location.go(this.getLocation().pathname.replace(`/${currentLang}`, `/${lang}`));
      }
     
    }
    else
    {
      this.location.go(this.getLocation().pathname.replace(`/${currentLang}`, `/${lang}`));
    }
   
    location.reload();
  }

  detectBrowserLang() {
    let selectedLanguage;
    let selectedLang = this.location[navigator.language.split('-')[0]];
    if (selectedLang) {
      selectedLanguage = selectedLang;
    }
    else {
      selectedLanguage = 'en';
    }
    return selectedLanguage;
  }
}
